<template>
	<div class="group-users">
		<v-row no-gutters>
			<v-col cols="12">
				<div class="flex-space-between--center" :class="{ flexJustifyEnd: !tableTitle }">
					<div class="table-title" v-if="tableTitle">{{ tableTitle }}</div>
					<div class="search-field"><AppSearch :searchString.sync="searchString" placeholder="Search users" /></div>
				</div>
				<v-row no-gutters class="align-center">
					<v-col cols="12" class="mt-3">
						<v-simple-table class="users_table" fixed-header>
							<template v-slot:default>
								<thead>
									<tr>
										<th class="text-left">User</th>
										<th class="text-left">Name</th>
										<th class="text-left">Email</th>
										<th class="text-left">Issues</th>
										<th class="text-left">Workspace role</th>
										<th style="width: 70px"></th>
									</tr>
								</thead>
								<tbody v-if="filteredUsers.length > 0">
									<tr
										v-for="user in filteredUsers"
										:key="getUserKey(user)"
										@mouseover="mouseOver(user)"
										@mouseleave="mouseLeave(user)"
										class="no-select user"
									>
										<td class="py-3">
											<InfoAvatar :user="user" />
										</td>
										<td>{{ user.name || ' - ' }}</td>
										<td>{{ user.email }}</td>
										<td>-</td>
										<td>
											{{ getRoleTitle(user.role) }}
										</td>
										<td>
											<div v-if="hasEditPermissions">
												<v-menu absolute right bottom>
													<template v-slot:activator="{ on, attrs }">
														<v-btn
															icon
															fab
															x-small
															rounded
															class="menu_btn"
															:class="{ show: hoverLine === getUserKey(user) }"
															:disabled="hoverLine !== getUserKey(user)"
															v-bind="attrs"
															v-on="on"
														>
															<SIcon name="dots-h" class="si" iconColor="#959DA1" style="top: -3px; left: -1px" :width="14"></SIcon>
														</v-btn>
													</template>
													<v-list>
														<v-list-item
															v-for="(item, index) in getMenuItems()"
															:key="`${getUserKey(user)}_${index}`"
															@click="menuAction(item, user)"
														>
															<v-list-item-title>{{ item.title }}</v-list-item-title>
														</v-list-item>
													</v-list>
												</v-menu>
											</div>
										</td>
									</tr>
								</tbody>
								<tr v-else>
									<span>No Users</span>
								</tr>
							</template>
						</v-simple-table>
					</v-col>
				</v-row>
			</v-col>
			<RemoveGroupUserDialog
				:userName="dialogUser.name"
				:groupName="group.name"
				@ok="removeFromGroup"
				@cancel="removeUserFromGroupDialogShow = false"
				:showDialog.sync="removeUserFromGroupDialogShow"
			/>
		</v-row>
	</div>
</template>

<script>
import { mapActions } from 'vuex';

import { teamMembers } from '@/store/modules/account/getters';
import { getGroups, createGroup, updateGroup, removeGroupUser } from '@/store/modules/accountGroups/actions';

import RemoveGroupUserDialog from '../../dialogs/settings/groups/RemoveGroupUserDialog';
import InfoAvatar from '@/components/SettingsManageUsersInfoAvatar';

import { mapRoleToTitle } from '../user.const';
import { mapGettersShorthand } from '@/store/utils/mappers';

export default {
	name: 'GroupUsers',
	components: {
		RemoveGroupUserDialog,
		InfoAvatar,
	},
	props: {
		selectedGroup: { type: Object },
		tableTitle: { type: String },
		hasEditPermissions: { type: Boolean },
	},
	computed: {
		...mapGettersShorthand({ teamMembers }),
		group() {
			return this.selectedGroup || { name: '' };
		},
		groupUserIds() {
			return this.group.users;
		},
		allGroupUsers() {
			if (!this.groupUserIds || this.groupUserIds.length === 0) {
				return [];
			}
			return this.teamMembers.filter((x) => this.groupUserIds.includes(x.user_id));
		},
		filteredUsers() {
			const allGroupUsers = this.allGroupUsers;
			if (this.searchString) {
				return allGroupUsers.filter((u) => u.name.toLowerCase().includes(this.searchString.toLowerCase()));
			}
			return allGroupUsers;
		},
	},
	methods: {
		...mapActions([getGroups.fullPath, createGroup.fullPath, updateGroup.fullPath, removeGroupUser.fullPath]),
		userCount(group) {
			return group?.users?.length || 0;
		},
		getMenuItems() {
			return [{ id: 0, title: 'Remove from group', action: this.removeFromGroupDialog }];
		},
		removeFromGroupDialog(user) {
			this.dialogUser = user;
			this.removeUserFromGroupDialogShow = true;
		},
		removeFromGroup() {
			this.removeUserFromGroupDialogShow = false;
			this[removeGroupUser.fullPath]({ id: this.group.id, user_id: this.dialogUser.user_id });
		},
		menuAction(item, user) {
			item.action(user);
			console.log('menuAction :');
		},
		getUserKey(user) {
			return `${user.is_invitation_pending ? 'temp_' : ''}${user.user_id}`;
		},
		mouseOver(user) {
			this.hoverLine = this.getUserKey(user);
		},
		mouseLeave() {
			this.hoverLine = -1;
		},
		getRoleTitle(roleCode) {
			return mapRoleToTitle(roleCode);
		},
	},
	async mounted() {
		try {
			await this[getGroups.fullPath]();
		} catch (err) {
			this.$toast.error('Failed getting all groups');
		}
	},
	data: () => ({
		hoverLine: -1,
		searchString: '',
		dialogUser: { name: '' },
		removeUserFromGroupDialogShow: false,
	}),
};
</script>

<style scoped lang="scss">
h4.reg {
	font-weight: 400 !important;
}
th {
	border-bottom: 1px solid #93a1bb !important;
	color: #354052 !important;
	font-weight: 600 !important;
	font-size: 12px !important;
	padding-bottom: 0px !important;
	line-height: 20px !important;
	height: 36px !important;
}
td {
	border-bottom: 1px solid #eff1f7 !important;
}
.menu_btn {
	border: 1px solid #959da1 !important;
	width: 25px;
	height: 25px;
	background-color: var(--page-background);
	transition: all 0.2s;
	opacity: 0;
}
.menu_btn.show {
	opacity: 1;
}
.men_card {
	width: 210px;
	z-index: 5;
	border-radius: 2px !important;
	border-bottom-right-radius: 6px !important;
}
.user {
	cursor: pointer;
}
.flexJustifyEnd {
	justify-content: flex-end;
}
</style>
